import MetricRing from './dataviz/MetricRing'
import Befi20 from './befi20/View'
import ProtectLiveDream from './protectlivedream/View'
import AreaChart from './dataviz/AreaChart'
import RiskProfile from './3driskprofile/View'
import Montecarlo from './montecarlo/View'
import GoalSummary from './goalsummary/View'
import GoalSummaryItem from './goalsummary/GoalSummaryItem'
import PLDCard from './protectlivedream/PLDCard'
import ComparisonCard from './befi20/ComparisonCard'

const abundanceEngineExports = {
  Befi20,
  Befi20ComparisonCard: ComparisonCard,
  ProtectLiveDream,
  PLDCard,
  RiskProfile,
  Montecarlo,
  GoalSummary,
  GoalSummaryItem,
  OCPAreaChart: AreaChart,
  OCPMetricRing: MetricRing
}

export default abundanceEngineExports
